function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import App from 'modules/App';
import messages from '../../messages';
import styles from './ContourCloudInfo.pcss';
var _React_PureComponent;
class ContourCloudInfo extends (_React_PureComponent = React.PureComponent) {
    get countrySettings() {
        const { countryCode } = this.props.identity;
        return get(find(this.props.countries, {
            alpha2Code: countryCode
        }), 'settings', {});
    }
    renderInfo() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx("p", {
                className: `text--paragraph ${styles.info}`,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.contourCloudInfo))
            })
        });
    }
    renderStores() {
        const { androidStoreURL, iosStoreURL } = this.countrySettings;
        return /*#__PURE__*/ _jsxs("div", {
            className: "col-auto",
            children: [
                /*#__PURE__*/ _jsx("a", {
                    href: androidStoreURL,
                    target: "_blank",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/aid/assets/svg/google-play.svg",
                        alt: "Google Play"
                    })
                }),
                /*#__PURE__*/ _jsx("a", {
                    href: iosStoreURL,
                    target: "_blank",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/aid/assets/svg/apple-app-store.svg",
                        className: "ml-5",
                        alt: "Apple App Store"
                    })
                })
            ]
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row justify-content-between",
            children: [
                this.renderInfo(),
                this.renderStores()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx("h3", {
                        className: "text--h3",
                        children: "Contour Cloud"
                    })
                }),
                this.renderContent()
            ]
        });
    }
}
_define_property(ContourCloudInfo, "propTypes", {
    // Explicit props
    identity: PropTypes.shape({
        countryCode: PropTypes.string.isRequired
    }),
    // Implicit props
    countries: PropTypes.arrayOf(App.shapes.country)
});
const mapStateToProps = (state)=>({
        countries: App.selectors.countries(state)
    });
const ConnectedContourCloudInfo = connect(mapStateToProps)(ContourCloudInfo);
export default withStyles(styles)(ConnectedContourCloudInfo);
